__turbopack_context__.v({
  "confirming": "_1CmWuW_confirming",
  "fillEffect": "_1CmWuW_fillEffect",
  "popoverContent": "_1CmWuW_popoverContent",
  "tipAmount": "_1CmWuW_tipAmount",
});
